import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { css } from '@emotion/react';
import { getStoredAdminPassword } from '@/context/SiteDataContext';
const ADMIN_USER = 'admin';
const AdminLogin = ({ onLogin, onClose, redirectToLogin = false }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');
        if (username === ADMIN_USER && password === getStoredAdminPassword())
            onLogin(true);
        else
            setError('Hibás felhasználónév vagy jelszó.');
    };
    return (_jsx("div", { css: backdrop, role: "presentation", onClick: (e) => e.target === e.currentTarget && onClose(), children: _jsxs("div", { css: modal, role: "dialog", "aria-modal": "true", "aria-labelledby": "login-title", onClick: (e) => e.stopPropagation(), children: [_jsx("div", { css: accentLine, "aria-hidden": true }), _jsx("p", { css: badge, children: "Administr\u00E1tori bel\u00E9p\u00E9s" }), _jsx("h2", { id: "login-title", css: title, children: "Minimal Car" }), _jsxs("p", { css: subtitle, children: ["Felhaszn\u00E1l\u00F3n\u00E9v: ", _jsx("strong", { children: "admin" }), " \u00B7 jelsz\u00F3: ", _jsx("strong", { children: "admin" }), " (alap)"] }), _jsxs("form", { onSubmit: handleSubmit, css: form, children: [_jsxs("label", { css: field, children: ["Felhaszn\u00E1l\u00F3n\u00E9v", _jsx("input", { autoComplete: "username", value: username, onChange: (e) => setUsername(e.target.value), placeholder: "admin", css: input, required: true })] }), _jsxs("label", { css: field, children: ["Jelsz\u00F3", _jsx("input", { autoComplete: "current-password", type: "password", value: password, onChange: (e) => setPassword(e.target.value), placeholder: "\u2022\u2022\u2022\u2022\u2022", css: input, required: true })] }), error && _jsx("p", { css: err, children: error }), getStoredAdminPassword() !== 'admin' ? (_jsx("p", { css: hint, children: "Ha m\u00E1r m\u00F3dos\u00EDtotta a jelsz\u00F3t az \u201E\u00C1ltal\u00E1nos\u201D admin oldalon, a t\u00E1rolt jelsz\u00F3t adja meg." })) : null, _jsxs("div", { css: actions, children: [_jsx("button", { type: "submit", css: btnPrimary, children: "Bel\u00E9p\u00E9s" }), _jsx("button", { type: "button", onClick: onClose, css: btnMuted, children: redirectToLogin ? 'Vissza a főoldalra' : 'Mégse' })] })] })] }) }));
};
const backdrop = css `
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  background: radial-gradient(circle at 50% -20%, rgba(255, 30, 30, 0.18), transparent 55%), rgba(8, 8, 12, 0.72);
  backdrop-filter: blur(10px);
`;
const modal = css `
  position: relative;
  width: min(440px, 100%);
  padding: clamp(2rem, 5vw, 2.65rem);
  border-radius: 16px;
  background: linear-gradient(165deg, #141416 0%, #0f0f12 58%, #121016 100%);
  border: 1px solid rgba(201, 162, 39, 0.35);
  box-shadow:
    0 48px 100px rgba(0, 0, 0, 0.55),
    inset 0 1px 0 rgba(255, 255, 255, 0.06),
    inset 0 0 36px rgba(255, 30, 30, 0.08);
`;
const accentLine = css `
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  width: 88px;
  height: 3px;
  border-radius: 0 0 5px 5px;
  background: linear-gradient(90deg, #FFD100, #FF1E1E, #FFD100);
`;
const badge = css `
  margin: 0.35rem 0 0;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.24em;
  text-transform: uppercase;
  color: #FFD100;
`;
const title = css `
  margin: 0.35rem 0 0;
  font-size: clamp(1.85rem, 4vw, 2.35rem);
  font-weight: 300;
  font-family: Georgia, 'Times New Roman', serif;
  letter-spacing: 0.04em;
  color: #faf7f0;
`;
const subtitle = css `
  margin: 0.75rem 0 1.5rem;
  font-size: 0.82rem;
  line-height: 1.55;
  color: #a8a29a;

  strong {
    color: #e7e5e1;
    font-weight: 800;
  }
`;
const form = css `
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
const field = css `
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  font-size: 0.74rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #9ca3af;
`;
const input = css `
  padding: 0.85rem 1rem;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.04);
  color: #f9fafb;
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: normal;
  text-transform: none;

  &::placeholder {
    color: #6b7280;
    font-weight: 400;
  }
  &:focus {
    outline: none;
    border-color: rgba(201, 162, 39, 0.55);
    box-shadow: 0 0 0 3px rgba(255, 30, 30, 0.15);
  }
`;
const err = css `
  margin: 0;
  color: #fecaca;
  font-size: 0.87rem;
  font-weight: 600;
`;
const hint = css `
  margin: 0;
  font-size: 0.78rem;
  color: #9ca3af;
  line-height: 1.45;
`;
const actions = css `
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-top: 0.35rem;
`;
const btnPrimary = css `
  flex: 1;
  min-width: 120px;
  padding: 0.88rem 1.25rem;
  border: none;
  border-radius: 10px;
  font-weight: 800;
  font-size: 0.85rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  cursor: pointer;
  color: #fff;
  background: linear-gradient(135deg, #FF1E1E 0%, #C40000 100%);
  box-shadow: 0 10px 28px rgba(255, 30, 30, 0.35);
  &:hover {
    filter: brightness(1.05);
  }
`;
const btnMuted = css `
  padding: 0.88rem 1.15rem;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: transparent;
  color: #d1d5db;
  font-weight: 700;
  font-size: 0.85rem;
  cursor: pointer;
  &:hover {
    background: rgba(255, 255, 255, 0.06);
  }
`;
export default AdminLogin;
